import React from 'react';
import Navbar from '../components/Navbar';
import HlcFooter from '../components/HlcFooter';
import { useNavigate } from 'react-router-dom';
import ResidentialImg from '../assets/indoor/hlc-residential-indoor-lighting.webp';
import CommercialImg from '../assets/indoor/hlc-commercial-indoor-lighting.webp';
import IndustrialImg from '../assets/indoor/hlc-industrial-lighting.webp';
import OutdoorImg from '../assets/indoor/hlc-outdoor-lighting.webp';

const SolutionsPage = () => {
      const navigate = useNavigate();
      const handleClick = ({screen}) => {
    // Navigate to your ResidentialPage route
    navigate(screen);
  };
  return (
  <>
  <Navbar />
    <div style={{marginTop:100}} className="solutions-page">
      {/* Page Intro Section */}
      <section className="hlc-page-intro">
        <div className="hlc-page-intro__inner">
          <h1>Lighting Solutions for Every Environment</h1>
          <p>Residential, commercial, industrial and outdoor LED lighting solutions
            engineered for performance, efficiency and long-term reliability.</p>
        </div>
      </section>

      {/* Solutions Grid Section */}
      <section className="hlc-sol" aria-label="Lighting Solutions">
        <div className="hlc-sol__inner">
          <header className="hlc-sol__head"></header>

          <div className="hlc-sol__grid">
            {/* Residential */}
            <a onClick={() => handleClick({screen: "/residential"})} className="sol-card"  style={{cursor:'pointer'}}>
              <div className="sol-card__imgwrap">
                <img decoding="async" src={ResidentialImg} alt="Residential Lighting" />
                <span className="sol-card__chip">Homes</span>
              </div>
              <div className="sol-card__body">
                <h3 className="sol-card__title">Residential Lighting</h3>
                <p className="sol-card__text">
                  Warm, comfortable lighting for living rooms, bedrooms, kitchens and outdoor home areas.
                </p>
                <ul className="sol-card__bullets">
                  <li>• Soft glare control</li>
                  <li>• Energy-saving LEDs</li>
                  <li>• Modern styles</li>
                </ul>
                <span className="sol-card__cta">Explore Residential →</span>
              </div>
            </a>

            {/* Commercial */}
            <a onClick={() => handleClick({screen: "/commercial"})} className="sol-card" style={{cursor:'pointer'}}>
              <div className="sol-card__imgwrap">
                <img decoding="async" src={CommercialImg} alt="Commercial Lighting" />
                <span className="sol-card__chip">Offices</span>
              </div>
              <div className="sol-card__body">
                <h3 className="sol-card__title">Commercial Lighting</h3>
                <p className="sol-card__text">
                  Bright, uniform illumination for offices, malls, hospitality, schools and workspaces.
                </p>
                <ul className="sol-card__bullets">
                  <li>• Uniform lux levels</li>
                  <li>• Low maintenance</li>
                  <li>• Clean aesthetics</li>
                </ul>
                <span className="sol-card__cta">Explore Commercial →</span>
              </div>
            </a>

            {/* Industrial */}
            <a onClick={() => handleClick({screen: "/industrial"})} className="sol-card" style={{cursor:'pointer'}}>
              <div className="sol-card__imgwrap">
                <img decoding="async" src={IndustrialImg} alt="Industrial Lighting" />
                <span className="sol-card__chip">Factories</span>
              </div>
              <div className="sol-card__body">
                <h3 className="sol-card__title">Industrial Lighting</h3>
                <p className="sol-card__text">
                  High-output lighting built for warehouses, workshops and demanding industrial environments.
                </p>
                <ul className="sol-card__bullets">
                  <li>• High lumen output</li>
                  <li>• Durable build</li>
                  <li>• Wide coverage</li>
                </ul>
                <span className="sol-card__cta">Explore Industrial →</span>
              </div>
            </a>

            {/* Outdoor & Landscape */}
            <a onClick={() => handleClick({screen: "/shop"})} className="sol-card" >
              <div className="sol-card__imgwrap">
                <img decoding="async" src={OutdoorImg} alt="Outdoor & Landscape Lighting" />
                <span className="sol-card__chip">Outdoor</span>
              </div>
              <div className="sol-card__body">
                <h3 className="sol-card__title">Outdoor & Landscape</h3>
                <p className="sol-card__text">
                  Weather-resistant lighting for streets, boundary walls, gardens, pathways and facades.
                </p>
                <ul className="sol-card__bullets">
                  <li>• IP-rated options</li>
                  <li>• Security visibility</li>
                  <li>• Landscape accents</li>
                </ul>
                <span className="sol-card__cta">Explore Outdoor →</span>
              </div>
            </a>

            {/* Retail & Showrooms */}
            <a onClick={() => handleClick({screen: "/shop"})} className="sol-card">
              <div className="sol-card__imgwrap">
                <img decoding="async" src={CommercialImg} alt="Retail & Showrooms Lighting" />
                <span className="sol-card__chip">Retail</span>
              </div>
              <div className="sol-card__body">
                <h3 className="sol-card__title">Retail & Showrooms</h3>
                <p className="sol-card__text">
                  Product-focused lighting to enhance displays, colors and customer experience in stores.
                </p>
                <ul className="sol-card__bullets">
                  <li>• Display highlighting</li>
                  <li>• Premium ambience</li>
                  <li>• Track & spot style</li>
                </ul>
                <span className="sol-card__cta">Explore Retail →</span>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Solutions CTA Section */}
      <section className="hlc-sol-cta">
        <div className="hlc-sol-cta__inner">
          <div className="hlc-sol-cta__content">
            <span className="hlc-sol-cta__tag">Need Assistance?</span>
            <h2>Talk to Our Lighting Experts</h2>
            <p>
              Not sure which lighting solution fits your space?
              Our experts will help you choose the right products for performance,
              efficiency and long-term reliability.
            </p>

            <div className="hlc-sol-cta__actions">
              <button type="button" onClick={() => navigate('/contact')} className="btn-primary">
                Request Consultation
              </button>

              <a href="https://wa.me/923337244858" target="_blank" rel="noopener noreferrer" className="btn-outline">
                WhatsApp Us
              </a>
            </div>
          </div>

          <div className="hlc-sol-cta__visual">
            <div className="visual-box">
              <div className="visual-icon">💡</div>
              <h4>Why Choose HLC?</h4>
              <ul>
                <li>• Energy-efficient LED solutions</li>
                <li>• Residential, Commercial & Industrial expertise</li>
                <li>• Trusted quality & modern designs</li>
                <li>• Professional project support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects Section */}
      <section className="hlc-projects">
        <div className="hlc-projects__head">
          <span className="hlc-projects__tag">Our Work</span>
          <h2>Featured Lighting Projects</h2>
          <p>
            Explore how HLC lighting solutions are transforming residential,
            commercial, industrial and retail environments across Pakistan.
          </p>
        </div>

        <div className="hlc-projects__grid">
          <div className="project-card">
            <img decoding="async" src={ResidentialImg} alt="Residential Lighting Project" />
            <div className="project-body">
              <h3>Luxury Residential Lighting</h3>
              <p className="project-meta">Residential • LED Bulbs & Panels</p>
              <p className="project-desc">
                Energy-efficient and elegant lighting solutions designed to enhance
                comfort, ambience and modern living spaces.
              </p>
            </div>
          </div>

          <div className="project-card">
            <img decoding="async" src={CommercialImg} alt="Commercial Lighting Project" />
            <div className="project-body">
              <h3>Commercial Office Spaces</h3>
              <p className="project-meta">Commercial • Downlights & Panels</p>
              <p className="project-desc">
                High-performance lighting layouts delivering productivity,
                uniform illumination and energy savings.
              </p>
            </div>
          </div>

          <div className="project-card">
            <img decoding="async" src={IndustrialImg} alt="Industrial Lighting Project" />
            <div className="project-body">
              <h3>Industrial Facilities</h3>
              <p className="project-meta">Industrial • High Bay & T Series</p>
              <p className="project-desc">
                Durable, high-lumen lighting systems engineered for warehouses,
                factories and heavy-duty environments.
              </p>
            </div>
          </div>
        </div>

      </section>

      {/* Certifications Section */}
      <section className="hlc-cert">
        <div className="hlc-cert__wrap">
          <div className="hlc-cert__content">
            <span className="hlc-cert__eyebrow">Quality & Compliance</span>
            <h2>Built to Global Standards</h2>
            <p className="hlc-cert__intro">
              Every HLC lighting product is engineered, tested and certified
              to meet international safety, performance and environmental benchmarks.
            </p>

            <ul className="hlc-cert__points">
              <li>International manufacturing & quality control processes</li>
              <li>Compliance with global electrical & safety regulations</li>
              <li>Environment-friendly materials & energy efficiency standards</li>
              <li>Consistent performance verified through laboratory testing</li>
            </ul>
          </div>

          <div className="hlc-cert__badges">
            <div className="cert-badge">
              <span>ISO</span>
              <p>ISO Certified Manufacturing</p>
            </div>

            <div className="cert-badge">
              <span>CE</span>
              <p>European Safety Compliance</p>
            </div>

            <div className="cert-badge">
              <span>RoHS</span>
              <p>Eco-Friendly & Lead-Free</p>
            </div>

            <div className="cert-badge">
              <span>LM</span>
              <p>LM-79 / LM-80 Tested</p>
            </div>

            <div className="cert-badge">
              <span>QC</span>
              <p>100% Quality Inspection</p>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        :root {
          --hlc-magenta: #9b1f6c;
          --hlc-plum: #542757;
          --hlc-navy: #35335b;
          --hlc-line: #eceaf1;
          --hlc-bg: #f7f7fb;
          --hlc-primary: #9b1f6c;
          --hlc-dark: #35335b;
          --hlc-gray: #666;
          --hlc-muted: #666;
          --hlc-border: #e6e6ee;
        }

        /* Page Intro Styles */
        .hlc-page-intro {
          background: #fafafa;
          padding: 36px 16px 24px;
          font-family: Figtree, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
        }

        .hlc-page-intro__inner {
          max-width: 1200px;
          margin: 0 auto;
        }

        .hlc-page-intro h1 {
          margin: 0 0 6px;
          font-size: 32px;
          font-weight: 800;
          letter-spacing: -0.02em;
          color: #111827;
        }

        .hlc-page-intro p {
          margin: 0;
          font-size: 14px;
          color: #4b5563;
        }

        /* Solutions Grid Styles */
        .hlc-sol {
          width: 100%;
          padding: clamp(28px, 5vw, 44px) 0;
          background: linear-gradient(180deg, var(--hlc-bg) 0%, #fff 100%);
          font-family: "Open Sans", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
          color: #141320;
        }

        .hlc-sol__inner {
          width: min(1200px, 92vw);
          margin: 0 auto;
        }

        .hlc-sol__head {
          text-align: center;
          margin-bottom: clamp(18px, 3vw, 28px);
        }

        .hlc-sol__grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: clamp(14px, 2vw, 18px);
          margin-top: clamp(14px, 2.5vw, 22px);
        }

        .sol-card {
          display: flex;
          flex-direction: column;
          text-decoration: none;
          background: #fff;
          border: 1px solid var(--hlc-line);
          box-shadow: 0 10px 24px rgba(20, 19, 32, 0.06);
          overflow: hidden;
          color: #141320;
          transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
        }

        .sol-card:hover {
          transform: translateY(-4px);
          border-color: rgba(155, 31, 108, 0.40);
          box-shadow: 0 18px 40px rgba(155, 31, 108, 0.18);
        }

        .sol-card__imgwrap {
          position: relative;
          aspect-ratio: 4/3;
          background: #f3f3f7;
          overflow: hidden;
        }

        .sol-card__imgwrap img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.02);
          transition: transform 0.45s ease;
        }

        .sol-card:hover .sol-card__imgwrap img {
          transform: scale(1.06);
        }

        .sol-card__chip {
          position: absolute;
          left: 12px;
          top: 12px;
          padding: 6px 10px;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          background: rgba(20, 19, 32, 0.82);
          color: #fff;
        }

        .sol-card__body {
          padding: 14px 14px 16px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          flex: 1;
        }

        .sol-card__title {
          margin: 0;
          font-size: 16px;
          font-weight: 800;
          color: var(--hlc-navy);
        }

        .sol-card__text {
          margin: 0;
          font-size: 13px;
          color: #55536a;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .sol-card__bullets {
          margin: 2px 0 0;
          padding-left: 16px;
          color: #55536a;
          font-size: 13px;
          line-height: 1.55;
        }

        .sol-card__bullets li {
          margin: 2px 0;
        }

        .sol-card__cta {
          margin-top: auto;
          display: inline-block;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--hlc-magenta);
        }

        .sol-card:hover .sol-card__cta {
          color: var(--hlc-plum);
        }

        /* CTA Section Styles */
        .hlc-sol-cta {
          padding: 70px 0;
          background: linear-gradient(135deg, #ffffff 0%, var(--hlc-bg) 100%);
          font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        }

        .hlc-sol-cta__inner {
          max-width: 1200px;
          margin: auto;
          padding: 0 16px;
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
          gap: 40px;
          align-items: center;
        }

        .hlc-sol-cta__tag {
          display: inline-block;
          font-size: 11px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #666;
          margin-bottom: 8px;
        }

        .hlc-sol-cta__content h2 {
          font-size: 32px;
          margin: 0 0 12px;
          color: var(--hlc-dark);
        }

        .hlc-sol-cta__content p {
          font-size: 15px;
          color: #555;
          max-width: 520px;
        }

        .hlc-sol-cta__actions {
          display: flex;
          gap: 14px;
          margin-top: 22px;
        }

        .btn-primary {
          padding: 14px 26px;
          background: var(--hlc-primary);
          color: #fff;
          font-weight: 800;
          text-decoration: none;
          border: 2px solid var(--hlc-primary);
        }

        .btn-primary:hover {
          background: #7f1958;
          border-color: #7f1958;
        }

        .btn-outline {
          padding: 14px 26px;
          background: #fff;
          color: var(--hlc-primary);
          font-weight: 800;
          text-decoration: none;
          border: 2px solid var(--hlc-primary);
        }

        .btn-outline:hover {
          background: var(--hlc-primary);
          color: #fff;
        }

        .hlc-sol-cta__visual .visual-box {
          background: #fff;
          border: 1px solid #eee;
          padding: 26px;
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
        }

        .visual-icon {
          font-size: 32px;
          margin-bottom: 10px;
        }

        .visual-box h4 {
          margin: 0 0 10px;
          font-size: 18px;
          color: var(--hlc-dark);
        }

        .visual-box ul {
          padding-left: 18px;
          margin: 0;
          font-size: 14px;
          color: #555;
        }

        .visual-box li {
          margin-bottom: 6px;
        }

        /* Projects Section Styles */
        .hlc-projects {
          padding: 80px 0;
          background: #ffffff;
          font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        }

        .hlc-projects__head {
          max-width: 760px;
          margin: 0 auto 46px;
          text-align: center;
        }

        .hlc-projects__tag {
          display: inline-block;
          font-size: 11px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #777;
          margin-bottom: 8px;
        }

        .hlc-projects__head h2 {
          font-size: 34px;
          margin: 0 0 10px;
          color: var(--hlc-dark);
        }

        .hlc-projects__head p {
          font-size: 15px;
          color: var(--hlc-gray);
        }

        .hlc-projects__grid {
          max-width: 1200px;
          margin: auto;
          padding: 0 16px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 26px;
        }

        .project-card {
          background: #fff;
          border: 1px solid #eee;
          transition: 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .project-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.10);
        }

        .project-card img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          background: #f5f5f5;
        }

        .project-body {
          padding: 18px;
        }

        .project-body h3 {
          font-size: 18px;
          margin: 0 0 6px;
          color: var(--hlc-dark);
        }

        .project-meta {
          font-size: 12px;
          font-weight: 700;
          color: var(--hlc-primary);
          margin-bottom: 8px;
        }

        .project-desc {
          font-size: 14px;
          color: #555;
        }

        .hlc-projects__cta {
          text-align: center;
          margin-top: 40px;
        }

        /* Certifications Section Styles */
        .hlc-cert {
          background: #ffffff;
          padding: 90px 0;
          font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        }

        .hlc-cert__wrap {
          max-width: 1200px;
          margin: auto;
          padding: 0 16px;
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 60px;
          align-items: center;
        }

        .hlc-cert__eyebrow {
          font-size: 11px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #888;
        }

        .hlc-cert__content h2 {
          font-size: 36px;
          margin: 8px 0 14px;
          color: var(--hlc-dark);
          line-height: 1.2;
        }

        .hlc-cert__intro {
          font-size: 16px;
          color: var(--hlc-muted);
          max-width: 520px;
          margin-bottom: 18px;
        }

        .hlc-cert__points {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .hlc-cert__points li {
          position: relative;
          padding-left: 22px;
          margin-bottom: 10px;
          font-size: 14px;
          color: #444;
        }

        .hlc-cert__points li::before {
          content: "✔";
          position: absolute;
          left: 0;
          top: 0;
          color: var(--hlc-primary);
          font-weight: 700;
        }

        .hlc-cert__badges {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 18px;
        }

        .cert-badge {
          border: 1px solid var(--hlc-border);
          padding: 26px 20px;
          text-align: center;
          transition: 0.3s ease;
        }

        .cert-badge:hover {
          border-color: var(--hlc-primary);
          box-shadow: 0 18px 38px rgba(155, 31, 108, 0.14);
          transform: translateY(-4px);
        }

        .cert-badge span {
          display: block;
          font-size: 26px;
          font-weight: 900;
          color: var(--hlc-primary);
          letter-spacing: 0.08em;
          margin-bottom: 6px;
        }

        .cert-badge p {
          font-size: 13px;
          color: #555;
          margin: 0;
        }

        /* Responsive Styles */
        @media (max-width: 992px) {
          .hlc-sol__grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
          .hlc-projects__grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 900px) {
          .hlc-sol-cta__inner {
            grid-template-columns: 1fr;
          }
          .hlc-sol-cta {
            padding: 50px 0;
          }
          .hlc-cert__wrap {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .hlc-cert__content h2 {
            font-size: 30px;
          }
        }

        @media (max-width: 768px) {
          .hlc-page-intro h1 {
            font-size: 26px;
          }
        }

        @media (max-width: 600px) {
          .hlc-sol__grid {
            grid-template-columns: 1fr;
          }
          .hlc-projects__grid {
            grid-template-columns: 1fr;
          }
          .hlc-projects {
            padding: 60px 0;
          }
        }

        @media (max-width: 520px) {
          .hlc-cert {
            padding: 60px 0;
          }
          .hlc-cert__badges {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
    <HlcFooter/>
  </>
  );
};

export default SolutionsPage;